import { Box } from '@mui/material';
import SearchBar from './SearchBar';
import DateRangeFilter from './DateRangeFilter';
import CompletedMissionsFilter from './CompletedMissionsFilter';

const FiltersContainer = () => {
    return (
        <Box 
            px={2} 
            pt={2}
            pb={1} 
            display="flex" 
            flexDirection="column"
            gap={2}
        >
            <Box 
                display="flex" 
                flexDirection="row" 
                alignItems="center"
                gap={2}
                >
                {/* Completed Missions Filter */}
                <CompletedMissionsFilter />

                {/* Date Range Filter */}
                <DateRangeFilter />
                
            </Box>

            {/* Search Bar */}
            <SearchBar />            
        </Box>
    );
};

export default FiltersContainer; 